import { FIELDTYPE } from "../constants/field-type"

export const defaultFormState = (commonFields) => {
        const commFieldObj = {}
        const newFields = commonFields.fields?.filter( field => field.FieldType !== FIELDTYPE.DIVIDER)
        if( newFields ){ 
            newFields.forEach( field => { 
                commFieldObj[field.FieldName2] = commFieldObj[field.FieldName2] ? commFieldObj[field.FieldName2] : "" 
            })
        }
        return { mainValues: commFieldObj };

}

// export const defaultFormState = (selectedForms , formsData , commonFields) => {
//     const selectedFormsDetails = selectedForms.map( idx => {
//         return formsData.find( form => idx === form.FormName )
//     })
//     if (selectedFormsDetails) {
//         const fieldState = selectedFormsDetails.map( idx => {
//             const fieldObj = {
//                 formName: idx.FormName,
//                 fieldValues: {},
//                 submitted: false
//             };
//             idx.Fields?.forEach( field => {
//                 fieldObj.fieldValues[field.FieldName2] = fieldObj.fieldValues[field.FieldName2] ? fieldObj.fieldValues[field.FieldName2] : ""
//             } )
//             return fieldObj;
//         })

//         const commFieldObj = {}
//         if( commonFields.fields ){ 
//             commonFields.fields.forEach( field => { commFieldObj[field.FieldName2] = commFieldObj[field.FieldName2] ? commFieldObj[field.FieldName2] : "" })
//         }
        
//         return { mainValues: commFieldObj , formValues: fieldState };

//     }
// }